import type * as Types from '../../../../gql/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type IndependentPracticeSubjectFieldsFragment = { __typename?: 'Subject', id: string, name: string, urlSlug: string, logoImageUrl?: string | null, adaptive: boolean, curriculumArea?: { __typename?: 'CurriculumArea', id: string, name: string } | null };

export type IndependentPracticeSubjectsQueryVariables = Types.Exact<{
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;


export type IndependentPracticeSubjectsQuery = { __typename?: 'RootQueryType', subjects?: { __typename?: 'KeysetPageOfSubject', count?: number | null, results?: Array<{ __typename?: 'Subject', id: string, name: string, urlSlug: string, logoImageUrl?: string | null, adaptive: boolean, curriculumArea?: { __typename?: 'CurriculumArea', id: string, name: string } | null }> | null } | null };

export type ClassroomIndependentPracticeSubjectsQueryVariables = Types.Exact<{
  classroomId: Types.Scalars['ID']['input'];
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;


export type ClassroomIndependentPracticeSubjectsQuery = { __typename?: 'RootQueryType', subjects?: { __typename?: 'KeysetPageOfSubject', count?: number | null, results?: Array<{ __typename?: 'Subject', id: string, name: string, urlSlug: string, logoImageUrl?: string | null, adaptive: boolean, curriculumArea?: { __typename?: 'CurriculumArea', id: string, name: string } | null }> | null } | null };

export const IndependentPracticeSubjectFieldsFragmentDoc = gql`
    fragment IndependentPracticeSubjectFields on Subject {
  id
  name
  urlSlug
  logoImageUrl
  adaptive
  curriculumArea {
    id
    name
  }
}
    `;
export const IndependentPracticeSubjectsDocument = gql`
    query IndependentPracticeSubjects($first: Int) {
  subjects(
    filter: {hidden: {eq: false}, adaptive: {eq: false}, userHasAccess: {eq: true}}
    sort: [{field: NAME, order: ASC}]
    first: $first
  ) {
    count
    results {
      ...IndependentPracticeSubjectFields
    }
  }
}
    ${IndependentPracticeSubjectFieldsFragmentDoc}`;

/**
 * __useIndependentPracticeSubjectsQuery__
 *
 * To run a query within a React component, call `useIndependentPracticeSubjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useIndependentPracticeSubjectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIndependentPracticeSubjectsQuery({
 *   variables: {
 *      first: // value for 'first'
 *   },
 * });
 */
export function useIndependentPracticeSubjectsQuery(baseOptions?: Apollo.QueryHookOptions<IndependentPracticeSubjectsQuery, IndependentPracticeSubjectsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IndependentPracticeSubjectsQuery, IndependentPracticeSubjectsQueryVariables>(IndependentPracticeSubjectsDocument, options);
      }
export function useIndependentPracticeSubjectsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IndependentPracticeSubjectsQuery, IndependentPracticeSubjectsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IndependentPracticeSubjectsQuery, IndependentPracticeSubjectsQueryVariables>(IndependentPracticeSubjectsDocument, options);
        }
// @ts-ignore
export function useIndependentPracticeSubjectsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<IndependentPracticeSubjectsQuery, IndependentPracticeSubjectsQueryVariables>): Apollo.UseSuspenseQueryResult<IndependentPracticeSubjectsQuery, IndependentPracticeSubjectsQueryVariables>;
export function useIndependentPracticeSubjectsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<IndependentPracticeSubjectsQuery, IndependentPracticeSubjectsQueryVariables>): Apollo.UseSuspenseQueryResult<IndependentPracticeSubjectsQuery | undefined, IndependentPracticeSubjectsQueryVariables>;
export function useIndependentPracticeSubjectsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<IndependentPracticeSubjectsQuery, IndependentPracticeSubjectsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<IndependentPracticeSubjectsQuery, IndependentPracticeSubjectsQueryVariables>(IndependentPracticeSubjectsDocument, options);
        }
export type IndependentPracticeSubjectsQueryHookResult = ReturnType<typeof useIndependentPracticeSubjectsQuery>;
export type IndependentPracticeSubjectsLazyQueryHookResult = ReturnType<typeof useIndependentPracticeSubjectsLazyQuery>;
export type IndependentPracticeSubjectsSuspenseQueryHookResult = ReturnType<typeof useIndependentPracticeSubjectsSuspenseQuery>;
export type IndependentPracticeSubjectsQueryResult = Apollo.QueryResult<IndependentPracticeSubjectsQuery, IndependentPracticeSubjectsQueryVariables>;
export const ClassroomIndependentPracticeSubjectsDocument = gql`
    query ClassroomIndependentPracticeSubjects($classroomId: ID!, $first: Int) {
  subjects(
    filter: {hidden: {eq: false}, adaptive: {eq: false}, studentClassroomSubjects: {classroomId: {eq: $classroomId}, restrictFreePractice: {eq: false}}}
    sort: [{field: NAME, order: ASC}]
    first: $first
  ) {
    count
    results {
      ...IndependentPracticeSubjectFields
    }
  }
}
    ${IndependentPracticeSubjectFieldsFragmentDoc}`;

/**
 * __useClassroomIndependentPracticeSubjectsQuery__
 *
 * To run a query within a React component, call `useClassroomIndependentPracticeSubjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useClassroomIndependentPracticeSubjectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClassroomIndependentPracticeSubjectsQuery({
 *   variables: {
 *      classroomId: // value for 'classroomId'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useClassroomIndependentPracticeSubjectsQuery(baseOptions: Apollo.QueryHookOptions<ClassroomIndependentPracticeSubjectsQuery, ClassroomIndependentPracticeSubjectsQueryVariables> & ({ variables: ClassroomIndependentPracticeSubjectsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ClassroomIndependentPracticeSubjectsQuery, ClassroomIndependentPracticeSubjectsQueryVariables>(ClassroomIndependentPracticeSubjectsDocument, options);
      }
export function useClassroomIndependentPracticeSubjectsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ClassroomIndependentPracticeSubjectsQuery, ClassroomIndependentPracticeSubjectsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ClassroomIndependentPracticeSubjectsQuery, ClassroomIndependentPracticeSubjectsQueryVariables>(ClassroomIndependentPracticeSubjectsDocument, options);
        }
// @ts-ignore
export function useClassroomIndependentPracticeSubjectsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ClassroomIndependentPracticeSubjectsQuery, ClassroomIndependentPracticeSubjectsQueryVariables>): Apollo.UseSuspenseQueryResult<ClassroomIndependentPracticeSubjectsQuery, ClassroomIndependentPracticeSubjectsQueryVariables>;
export function useClassroomIndependentPracticeSubjectsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ClassroomIndependentPracticeSubjectsQuery, ClassroomIndependentPracticeSubjectsQueryVariables>): Apollo.UseSuspenseQueryResult<ClassroomIndependentPracticeSubjectsQuery | undefined, ClassroomIndependentPracticeSubjectsQueryVariables>;
export function useClassroomIndependentPracticeSubjectsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ClassroomIndependentPracticeSubjectsQuery, ClassroomIndependentPracticeSubjectsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ClassroomIndependentPracticeSubjectsQuery, ClassroomIndependentPracticeSubjectsQueryVariables>(ClassroomIndependentPracticeSubjectsDocument, options);
        }
export type ClassroomIndependentPracticeSubjectsQueryHookResult = ReturnType<typeof useClassroomIndependentPracticeSubjectsQuery>;
export type ClassroomIndependentPracticeSubjectsLazyQueryHookResult = ReturnType<typeof useClassroomIndependentPracticeSubjectsLazyQuery>;
export type ClassroomIndependentPracticeSubjectsSuspenseQueryHookResult = ReturnType<typeof useClassroomIndependentPracticeSubjectsSuspenseQuery>;
export type ClassroomIndependentPracticeSubjectsQueryResult = Apollo.QueryResult<ClassroomIndependentPracticeSubjectsQuery, ClassroomIndependentPracticeSubjectsQueryVariables>;